export default "__VITE_ASSET__XszYAl5l__"